module.exports = __webpack_public_path__ + "resources/img/logo_JymGames.327b6bb3f4226dafbcdd1ef77370c06d.png";